module.exports = __webpack_public_path__ + "static/media/logo-sancor.a7461174.svg";